// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ActionEnvelope, ActionEnvelopeT } from '../tbs/action-envelope.js';
import { ActionLogEnvelope, ActionLogEnvelopeT } from '../tbs/action-log-envelope.js';
import { ErrorEnvelope, ErrorEnvelopeT } from '../tbs/error-envelope.js';
import { MapScriptFormDataEnvelope, MapScriptFormDataEnvelopeT } from '../tbs/map-script-form-data-envelope.js';
import { PlayerViewEnvelope, PlayerViewEnvelopeT } from '../tbs/player-view-envelope.js';
import { ReplayEnvelope, ReplayEnvelopeT } from '../tbs/replay-envelope.js';
import { StateEnvelope, StateEnvelopeT } from '../tbs/state-envelope.js';


export enum EnginePayload {
  NONE = 0,
  ActionEnvelope = 1,
  StateEnvelope = 2,
  PlayerViewEnvelope = 3,
  ReplayEnvelope = 4,
  ActionLogEnvelope = 5,
  ErrorEnvelope = 6,
  MapScriptFormDataEnvelope = 7
}

export function unionToEnginePayload(
  type: EnginePayload,
  accessor: (obj:ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope) => ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope|null
): ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope|null {
  switch(EnginePayload[type]) {
    case 'NONE': return null; 
    case 'ActionEnvelope': return accessor(new ActionEnvelope())! as ActionEnvelope;
    case 'StateEnvelope': return accessor(new StateEnvelope())! as StateEnvelope;
    case 'PlayerViewEnvelope': return accessor(new PlayerViewEnvelope())! as PlayerViewEnvelope;
    case 'ReplayEnvelope': return accessor(new ReplayEnvelope())! as ReplayEnvelope;
    case 'ActionLogEnvelope': return accessor(new ActionLogEnvelope())! as ActionLogEnvelope;
    case 'ErrorEnvelope': return accessor(new ErrorEnvelope())! as ErrorEnvelope;
    case 'MapScriptFormDataEnvelope': return accessor(new MapScriptFormDataEnvelope())! as MapScriptFormDataEnvelope;
    default: return null;
  }
}

export function unionListToEnginePayload(
  type: EnginePayload, 
  accessor: (index: number, obj:ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope) => ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope|null, 
  index: number
): ActionEnvelope|ActionLogEnvelope|ErrorEnvelope|MapScriptFormDataEnvelope|PlayerViewEnvelope|ReplayEnvelope|StateEnvelope|null {
  switch(EnginePayload[type]) {
    case 'NONE': return null; 
    case 'ActionEnvelope': return accessor(index, new ActionEnvelope())! as ActionEnvelope;
    case 'StateEnvelope': return accessor(index, new StateEnvelope())! as StateEnvelope;
    case 'PlayerViewEnvelope': return accessor(index, new PlayerViewEnvelope())! as PlayerViewEnvelope;
    case 'ReplayEnvelope': return accessor(index, new ReplayEnvelope())! as ReplayEnvelope;
    case 'ActionLogEnvelope': return accessor(index, new ActionLogEnvelope())! as ActionLogEnvelope;
    case 'ErrorEnvelope': return accessor(index, new ErrorEnvelope())! as ErrorEnvelope;
    case 'MapScriptFormDataEnvelope': return accessor(index, new MapScriptFormDataEnvelope())! as MapScriptFormDataEnvelope;
    default: return null;
  }
}
